<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { RAW_MATERIAL_PATH } from "@/path.js";
import add from "./add.vue";
import Batches from "./batches.vue";
import AddPrice from "./addPrice.vue";
import moment from "moment";
import Vendors from "./vendors.vue";
/* Dashboard component */
export default {
  components: {
    Layout,
    PageHeader,
    add: add,
    Batches,
    AddPrice,
    Vendors,
  },
  data() {
    return {
      title: "Raw Materials",
      items: [
        {
          text: "List",
        },
        {
          text: "Raw Materials",
          active: true,
        },
      ],
      selectedRawMaterial: {},
      raw_materials: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      filter: [],
      fields: [
        "name",
        "Vendors",
        "category",
        "description",
        "qty_received",
        "latest_price",
        "active",
        "actions",
      ],
      current_page: 1,
      search: "",
      trashed: false,
    };
  },
  watch: {
    trashed() {
      this.getRawMaterials();
    },
    current_page() {
      this.getRawMaterials();
    },
    search() {
      this.getRawMaterials();
    },
  },
  methods: {
    async getRawMaterials() {
      try {
        let response = await axios.get(this.base_url + RAW_MATERIAL_PATH.LIST, {
          params: {
            page: this.current_page,
            search: this.search,
            trashed: this.trashed,
          },
        });
        if (response.data.status == true) {
          this.raw_materials = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    showVendors(v) {
      this.selectedRawMaterial = v;
      this.$bvModal.show("open-vendors");
    },
    addRawMaterial() {
      this.selectedRawMaterial = {};
      this.$bvModal.show("bv-add-raw-material");
    },
    reload() {
      this.getRawMaterials();
      this.$bvModal.hide("open-add-price");
    },
    setEdit(d) {
      this.selectedRawMaterial = d;
      this.$bvModal.show("bv-add-raw-material");
    },
    async deactivate(e, d) {
      try {
        let res = await axios.post(
          this.base_url + RAW_MATERIAL_PATH.DEACTIVATE,
          {
            id: d.id,
            active: e,
          }
        );
        if (res.data.status) {
          this.$bvToast.toast("Successfully Deactivated", {
            title: `Raw Material Deactivated`,
            variant: "success",
            solid: true,
          });
          this.getRawMaterials();
        }
      } catch (error) {
        console.log(error);
        this.$bvToast.toast("Failed to deactivate", {
          title: error.message,
          variant: "error",
          solid: true,
        });
      }
    },
    openBatches(v) {
      this.selectedRawMaterial = v;
      this.$bvModal.show("open-batches");
    },
    openAddPrice(v) {
      this.selectedRawMaterial = v;
      this.$bvModal.show("open-add-price");
    },
    formatedDate(v) {
      return moment(v).format("YYYY-MM-DD");
    },
    async deleteData(d) {
      try {
        let response = await axios.delete(
          this.base_url + RAW_MATERIAL_PATH.DELETE,
          {
            params: {
              id: d.id,
            },
          }
        );
        if (response.data.status == true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: `Raw Material Deleted`,
            variant: "success",
            solid: true,
          });
          this.getRawMaterials();
        }
      } catch (e) {
        this.$bvToast.toast("Failed to delete", {
          title: e.message,
          variant: "error",
          solid: true,
        });
        console.log(e);
      }
    },
  },
  mounted() {
    this.getRawMaterials();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button
                  @click="addRawMaterial"
                  class="btn btn-primary mb-10 pb-10"
                  >Add Raw Material</b-button
                >
                <b-modal
                  id="bv-add-raw-material"
                  size="xl"
                  :title="
                    (Object.keys(selectedRawMaterial).length > 0
                      ? 'Edit'
                      : 'Add') + ' Raw Material'
                  "
                  hide-footer
                >
                  <add
                    @update="reload()"
                    :selectedRawMaterial="selectedRawMaterial"
                  ></add>
                </b-modal>
                <b-modal
                  id="open-batches"
                  size="xl"
                  :title="
                    (Object.keys(selectedRawMaterial).length > 0
                      ? selectedRawMaterial.name
                      : '') + ' Batches'
                  "
                >
                  <Batches :selectedRawMaterial="selectedRawMaterial"></Batches>
                </b-modal>
                <b-modal
                  id="open-add-price"
                  size="xl"
                  :title="
                    (Object.keys(selectedRawMaterial).length > 0
                      ? selectedRawMaterial.name
                      : '') + ' Price'
                  "
                  hide-footer
                >
                  <AddPrice
                    :selectedRawMaterial="selectedRawMaterial"
                  ></AddPrice>
                </b-modal>
                <b-modal id="open-vendors" size="sm">
                  <Vendors :vendors="selectedRawMaterial.vendor"></Vendors>
                </b-modal>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      debounce="300"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                    <!-- <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> -->
                  </label>
                </div>
              </div>
              <div class="col-2 float-right mt-4">
                <label>Trashed</label>
                <b-form-checkbox
                  v-model="trashed"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="raw_materials.key"
                :items="raw_materials.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
              >
                <template v-slot:cell(active)="row">
                  <b-form-checkbox
                    :checked="row.item.active == 1 ? true : false"
                    switch
                    @change="deactivate($event, row.item)"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(vendors)="row">
                  <b-button variant="primary" @click="showVendors(row.item)"
                    ><i class="fa fa-list"></i
                  ></b-button>
                </template>
                <template v-slot:cell(qty_received)="row">
                  {{
                    row.item.batches.length > 0
                      ? row.item.batches.reduce((a, c) => {
                          return a + c.qty_received;
                        }, 0)
                      : 0
                  }}
                  <b-button
                    class="ml-3"
                    size="sm"
                    @click="openBatches(row.item)"
                    ><i class="fa fa-list"></i
                  ></b-button>
                </template>
                <template v-slot:cell(latest_price)="row">
                  {{
                    row.item.price_data
                      ? "Rs." + row.item.price_data.unit_price
                      : ""
                  }}
                  {{
                    row.item.price_data ? "per " + row.item.price_data.uom : ""
                  }}<br />
                  {{
                    row.item.price_data
                      ? "(last updated : " +
                        formatedDate(row.item.price_data.created_at) +
                        ")"
                      : ""
                  }}
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button
                    @click="openAddPrice(row.item)"
                    variant="primary"
                    class="mr-2"
                  >
                    <i class="fa fa-money"> Add Price</i>
                  </b-button>
                  <b-button @click="setEdit(row.item)" variant="primary">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button
                    @click="deleteData(row.item)"
                    variant="danger"
                    class="ml-1"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="raw_materials.key"
                      v-model="current_page"
                      :total-rows="raw_materials.total"
                      :per-page="raw_materials.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
